'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('../../extends-f8003900.js');
var objectWithoutProperties = require('../../objectWithoutProperties-aa43106a.js');
var React = require('react');
var index = require('../../index-0e40e0c2.js');
var styles_colors_colorVariantsShape = require('../../styles/colors/colorVariantsShape.js');
var utils_hooks_useIntlAriaAttrs = require('../../utils/hooks/useIntlAriaAttrs.js');
var components_NuDSProvider_NuDSProvider = require('../NuDSProvider/NuDSProvider.js');
var utils_logger_logDeprecatedFeature_logDeprecatedFeature = require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
var defineProperty = require('../../defineProperty-3cad0327.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
var xstyledPropTypes_es = require('../../xstyled-prop-types.es-56667676.js');
var styles_breakpoints = require('../../breakpoints-7bb24b2d.js');
var utils_isType_isType = require('../../utils/isType/isType.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../GlobalStyle/GlobalStyle.js');
require('styled-components');
require('../../theme-340a6118.js');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20;
var textDecoration = xstyledStyledComponents_es.style({
  prop: 'textDecoration',
  cssProperty: 'textDecoration'
});
var textOverflow = xstyledStyledComponents_es.style({
  prop: 'textOverflow',
  cssProperty: 'textOverflow'
});
var wordBreak = xstyledStyledComponents_es.style({
  prop: 'wordBreak',
  cssProperty: 'wordBreak'
});
var gutterBottom = xstyledStyledComponents_es.style({
  prop: 'gutterBottom',
  cssProperty: 'marginBottom',
  themeGet: function themeGet(propValue) {
    return function () {
      return propValue * 16;
    };
  }
});
var whiteSpace = xstyledStyledComponents_es.style({
  prop: 'whiteSpace',
  cssProperty: 'whiteSpace'
});
var marginHorizontal = xstyledStyledComponents_es.style({
  prop: 'marginHorizontal',
  cssProperty: ['marginRight', 'marginLeft'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var marginVertical = xstyledStyledComponents_es.style({
  prop: 'marginVertical',
  cssProperty: ['marginTop', 'marginBottom'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var paddingHorizontal = xstyledStyledComponents_es.style({
  prop: 'paddingHorizontal',
  cssProperty: ['paddingRight', 'paddingLeft'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var paddingVertical = xstyledStyledComponents_es.style({
  prop: 'paddingVertical',
  cssProperty: ['paddingTop', 'paddingBottom'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var color = xstyledStyledComponents_es.style({
  prop: 'color',
  themeGet: xstyledStyledComponents_es.getColor
});
var legacyColor = xstyledStyledComponents_es.createStyleGenerator(function (props) {
  return {
    color: "".concat(styles_themeUtils.nuDSColor(props.color, props.colorVariant)())
  };
}, ['color']);
var styleProps = xstyledStyledComponents_es.compose(xstyledStyledComponents_es.layout, xstyledStyledComponents_es.textAlign, textDecoration, textOverflow, xstyledStyledComponents_es.overflow, wordBreak, xstyledStyledComponents_es.space, whiteSpace, marginHorizontal, marginVertical, paddingHorizontal, paddingVertical, color);

function appendDefaultFontFamily(newFontFamily) {
  // eslint-disable-next-line quotes
  var defaultFonts = "'Graphik-Regular', 'Gotham SSm A', 'Gotham SSm B', 'Helvetica Neue', Helvetica, Arial,sans-serif";
  return newFontFamily ? "".concat(newFontFamily, ", ").concat(defaultFonts) : defaultFonts;
}

var defaultStrong = ['supertitle', 'heading1', 'heading2', 'heading3', 'heading4', 'button', 'overline'];
var stylesByVariantMap = {
  supertitle: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      font-weight: 500;\n      letter-spacing: -0.03em;\n      font-size: 2.75rem;\n      line-height: 1.1;\n    "]))),
    md: xstyledStyledComponents_es.css(_templateObject2 || (_templateObject2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      font-size: 5.75rem;\n      line-height: 1.04;\n    "])))
  }),
  heading1: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject3 || (_templateObject3 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      font-weight: 500;\n      letter-spacing: -0.03em;\n      font-size: 2.25rem;\n      line-height: 1.16;\n    "]))),
    md: xstyledStyledComponents_es.css(_templateObject4 || (_templateObject4 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      font-size: 4rem;\n      line-height: 1;\n    "])))
  }),
  heading2: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject5 || (_templateObject5 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      font-weight: 500;\n      letter-spacing: -0.03em;\n      font-size: 1.875rem;\n      line-height: 1.2;\n    "]))),
    md: xstyledStyledComponents_es.css(_templateObject6 || (_templateObject6 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      font-size: 3rem;\n      line-height: 1.16;\n    "])))
  }),
  heading3: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject7 || (_templateObject7 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      font-weight: 500;\n      letter-spacing: -0.02em;\n      font-size: 1.5rem;\n      line-height: 1.32;\n    "]))),
    md: xstyledStyledComponents_es.css(_templateObject8 || (_templateObject8 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      letter-spacing: -0.03em;\n      font-size: 2.5rem;\n      line-height: 1.2;\n    "])))
  }),
  heading4: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject9 || (_templateObject9 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      font-weight: 500;\n      letter-spacing: -0.02em;\n      font-size: 1.25rem;\n      line-height: 1.22;\n    "]))),
    md: xstyledStyledComponents_es.css(_templateObject10 || (_templateObject10 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      font-size: 1.5rem;\n      line-height: 1.32;\n    "])))
  }),
  subtitle1: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject11 || (_templateObject11 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      letter-spacing: -0.01em;\n      font-size: 1.125rem;\n      line-height: 1.32;\n    "])))
  }),
  subtitle2: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject12 || (_templateObject12 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      letter-spacing: -0.01em;\n      font-size: 1rem;\n      line-height: 1.25;\n    "])))
  }),
  paragraph1: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject13 || (_templateObject13 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      letter-spacing: -0.01em;\n      font-size: 1rem;\n      line-height: 1.5;\n    "])))
  }),
  paragraph2: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject14 || (_templateObject14 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      letter-spacing: -0.01em;\n      font-size: 0.875rem;\n      line-height: 1.46;\n    "])))
  }),
  button: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject15 || (_templateObject15 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      letter-spacing: -0.01em;\n      font-size: 1rem;\n      line-height: 1;\n    "])))
  }),
  caption: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject16 || (_templateObject16 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      letter-spacing: -0.01em;\n      font-size: 0.875rem;\n      line-height: 1.25;\n    "])))
  }),
  overline: styles_breakpoints.breakpointsMedia({
    xs: xstyledStyledComponents_es.css(_templateObject17 || (_templateObject17 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      font-size: 0.75rem;\n      line-height: 1.35;\n      text-decoration: uppercase;\n    "])))
  })
};
/* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */

var createEllipsisStyle = function createEllipsisStyle(lines) {
  return xstyledStyledComponents_es.css(_templateObject18 || (_templateObject18 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  white-space: normal;\n"])), lines);
};
/* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */


var ellipsis = function ellipsis(_ref) {
  var lines = _ref.lines;
  if (!lines) return null;

  if (utils_isType_isType.isType('object', lines)) {
    var stylesByBreakPoints = Object.keys(lines).reduce(function (prev, key) {
      return _extends._extends({}, prev, defineProperty.defineProperty({}, key, createEllipsisStyle(lines[key])));
    }, {});
    return styles_breakpoints.breakpointsMedia(stylesByBreakPoints);
  }

  return createEllipsisStyle(lines);
};

var InnerTypography = xstyledStyledComponents_es.createSystemComponent(React__default['default'], 'span', styleProps);
var TypographyWrapper = xstyledStyledComponents_es.styled(InnerTypography).withConfig({
  shouldForwardProp: function shouldForwardProp(prop, validate) {
    return validate(prop) && !styleProps.meta.props.includes(prop);
  }
})(_templateObject19 || (_templateObject19 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  ", "\n  margin: 0;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_ref2) {
  var strong = _ref2.strong;
  return strong ? "font-family: ".concat(appendDefaultFontFamily('Graphik-Medium'), ";") : "font-family: ".concat(appendDefaultFontFamily(), ";");
}, ellipsis, gutterBottom, styleProps, xstyledStyledComponents_es.variant({
  variants: stylesByVariantMap
}), function (_ref3) {
  var hasLegacyColor = _ref3.hasLegacyColor;
  return hasLegacyColor && xstyledStyledComponents_es.css(_templateObject20 || (_templateObject20 = xstyledStyledComponents_es.taggedTemplateLiteral(["", ""])), legacyColor);
});
TypographyWrapper.displayName = 'TypographyWrapper';
TypographyWrapper.propTypes = xstyledPropTypes_es.getSystemPropTypes(styleProps);

var validateColorProps = function validateColorProps(_ref) {
  var color = _ref.color,
      colorVariant = _ref.colorVariant;
  var isValid = true;

  if (styles_themeUtils.isLegacyColor(color) && color !== 'inherit') {
    utils_logger_logDeprecatedFeature_logDeprecatedFeature.logDeprecatedFeature('single color is deprecated, use use color=\'color.default\' instead');
    isValid = false;
  }

  if (colorVariant) {
    utils_logger_logDeprecatedFeature_logDeprecatedFeature.logDeprecatedFeature('colorVariant is deprecated, use color=\'color.variant\' instead');
    isValid = false;
  }

  return isValid;
};

var variantTagMapping = {
  supertitle: 'h1',
  heading1: 'h1',
  heading2: 'h2',
  heading3: 'h3',
  heading4: 'h4',
  subtitle1: 'p',
  subtitle2: 'p',
  paragraph1: 'p',
  paragraph2: 'p',
  button: 'span',
  caption: 'span',
  overline: 'span'
};
var typographyVariantsPropType = index.PropTypes.oneOf(Object.keys(variantTagMapping));
var Typography = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var variant = props.variant,
      tag = props.tag,
      children = props.children,
      className = props.className,
      color = props.color,
      gutterBottom = props.gutterBottom,
      intlKey = props.intlKey,
      intlValues = props.intlValues,
      colorVariant = props.colorVariant,
      strong = props.strong,
      rest = objectWithoutProperties.objectWithoutProperties(props, ["variant", "tag", "children", "className", "color", "gutterBottom", "intlKey", "intlValues", "colorVariant", "strong"]);

  var _useContext = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext),
      formatMessage = _useContext.formatMessage;

  var intlAriaAttrs = utils_hooks_useIntlAriaAttrs['default'](props);
  var as = tag || variantTagMapping[variant];

  if (gutterBottom !== null && gutterBottom !== void 0 ? gutterBottom : false) {
    utils_logger_logDeprecatedFeature_logDeprecatedFeature.logDeprecatedFeature('gutterBottom is deprecated, use marginBottom instead of gutterBottom');
  }

  var hasLegacyColor = !validateColorProps({
    color: color,
    colorVariant: colorVariant
  });
  return /*#__PURE__*/React__default['default'].createElement(TypographyWrapper, _extends._extends({
    forwardedAs: as,
    className: className,
    color: color,
    colorVariant: colorVariant,
    gutterBottom: gutterBottom,
    variant: variant,
    hasLegacyColor: hasLegacyColor,
    strong: defaultStrong.includes(variant) ? true : strong,
    ref: ref
  }, intlAriaAttrs, rest), intlKey ? formatMessage({
    id: intlKey
  }, intlValues) : children);
});
Typography.defaultProps = {
  strong: false,
  children: undefined,
  className: undefined,
  color: 'inherit',
  // TODO: Remove it after upgrade color usage in all websites
  colorVariant: undefined,
  gutterBottom: 0,
  lines: undefined,
  tag: undefined,
  variant: 'subtitle1',
  intlKey: null,
  intlValues: {},
  margin: undefined,
  marginTop: undefined,
  marginBottom: undefined,
  marginLeft: undefined,
  marginRight: undefined,
  marginHorizontal: undefined,
  marginVertical: undefined,
  padding: undefined,
  paddingTop: undefined,
  paddingBottom: undefined,
  paddingLeft: undefined,
  paddingRight: undefined,
  paddingHorizontal: undefined,
  paddingVertical: undefined,
  width: undefined,
  height: undefined,
  minWidth: undefined,
  maxWidth: undefined,
  minHeight: undefined,
  maxHeight: undefined,
  size: undefined,
  display: undefined,
  verticalAlign: undefined,
  overflow: undefined,
  overflowX: undefined,
  overflowY: undefined,
  textOverflow: undefined,
  wordBreak: undefined,
  textDecoration: undefined,
  whiteSpace: undefined
};
var typographyShape = {
  strong: index.PropTypes.bool,

  /** The content of the component, it can be either another component or raw text */
  children: index.PropTypes.node,

  /** The class that will be applied to the HTML element */
  className: index.PropTypes.string,

  /**
   * The color of the text;
   * This can be a NuDS color token or an browser specific value (initial, inherit)
  */
  color: index.PropTypes.string,

  /**
   * The variant of the color that you want to use;
   * The variants can be found on "Colors" section
   * */
  colorVariant: styles_colors_colorVariantsShape['default'],

  /**
    Margin at the bottom of the component; It's computed in multiples of 16px
    (1 = 16px; 2 = 32px, etc.)
  */
  gutterBottom: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),

  /** An i18n key that will be used to search for content */
  intlKey: index.PropTypes.string,

  /** An object containing the values to be passed down to the internationalized message */
  intlValues: index.PropTypes.shape({}),

  /** The number of lines that can be showed */
  lines: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),

  /** The actual HTML element to be rendered */
  tag: index.PropTypes.elementType,

  /** The font style that will be rendered */
  variant: typographyVariantsPropType,
  margin: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  marginTop: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  marginBottom: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  marginLeft: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  marginRight: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  marginHorizontal: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  marginVertical: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  padding: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  paddingTop: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  paddingBottom: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  paddingLeft: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  paddingRight: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  paddingHorizontal: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  paddingVertical: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  width: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  height: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  minWidth: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  maxWidth: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  minHeight: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  maxHeight: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  size: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  display: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  verticalAlign: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  overflow: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  overflowX: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  overflowY: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  textOverflow: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  wordBreak: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  textDecoration: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  whiteSpace: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object])
};
Typography.propTypes = typographyShape;
Typography.displayName = 'Typography';

exports.default = Typography;
exports.typographyShape = typographyShape;
exports.typographyVariantsPropType = typographyVariantsPropType;
exports.variantTagMapping = variantTagMapping;
//# sourceMappingURL=Typography.js.map
